import { render, staticRenderFns } from "./ButtonSwiperArrow.vue?vue&type=template&id=45328f20&"
import script from "./ButtonSwiperArrow.vue?vue&type=script&lang=js&"
export * from "./ButtonSwiperArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports